import { DataPage } from "@xbs/muon";
import { IAction, IActionConfig, SpreadsheetEvents } from "../types";

export class RenameSheet implements IAction {
	public config: IActionConfig;
	public page: DataPage;

	constructor(config: IActionConfig) {
		this.config = config;
		this.page = config.activePage;
	}

	do() {
		const { sheets, dataStore, val, prev } = this.config;
		const item = sheets.getItem(prev);
		const activeSheet = this.config.spreadsheet.getActiveSheet().name;
		if (!item.prevValue) {
			sheets.update(item.id, { prevValue: item.value });
		}
		if (activeSheet === item.prevValue) {
			(this.config.spreadsheet as any)._activeSheetName = { name: val, id: item.id };
		}
		dataStore.renamePage(item.prevValue, val);
		sheets.update(prev, { value: val, prevValue: item.prevValue });
		this.config.grid.paint();
		this.config.spreadsheet.selection.setFocusedCell(this.config.spreadsheet.selection.getFocusedCell());
	}

	undo() {
		const { sheets, dataStore, val, prev } = this.config;
		const item = sheets.getItem(prev);
		dataStore.renamePage(val, item.prevValue);
		const activeSheet = this.config.spreadsheet.getActiveSheet().name;
		if (activeSheet === val) {
			(this.config.spreadsheet as any)._activeSheetName = { name: val, id: item.id };
		}
		sheets.update(prev, { value: item.prevValue, prevValue: item.prevValue });
		this.config.grid.paint();
		this.config.spreadsheet.selection.setFocusedCell(this.config.spreadsheet.selection.getFocusedCell());
	}
}
